@if (isDesktop) {
    <user-compliance-message></user-compliance-message>
}
<ng-container *ngrxLet="nLRegulatoryHelperService.displayPromoDetails$ as displayPromoDetails">
    @if (displayPromoDetails) {
        <div
            #baseLayout
            class="promohub-details-page promohub-targeted pm-page-max-width-md"
            [ngClass]="{ stickyHeader: device?.isMobile, optinExists: isOptinPresent }">
            <vn-header-bar
                [showClose]="promoDetailPageConfiguration?.showClose"
                [showBack]="promoDetailPageConfiguration?.showBack"
                [title]="title"
                [ngClass]="{ 'header-ctrl-light-ph': !device?.isMobile }"
                (onBack)="backClick()"
                (onClose)="closeClick()">
            </vn-header-bar>
            @if (tabs?.length > 0) {
                <div class="tabgroup-wrapper tab-group-bottom" [ngClass]="{ stickyHide: hideNavBar }">
                    <ds-tabs-group
                        (tabChanged)="changeCurrentTab($event)"
                        [activeTab]="tabIndex"
                        [variant]="designSystem?.dsTabsGroup?.variant"
                        [indicator]="designSystem?.dsTabsGroup?.indicator"
                        [inverse]="designSystem?.dsTabsGroup?.inverse"
                        [size]="designSystem?.dsTabsGroup?.size">
                        @for (tab of tabs; track tab; let i = $index) {
                            <ds-tab name="{{ i }}">
                                <ng-container *dsTabHeader>
                                    <div>
                                        {{ clientContent && clientContent.messages ? clientContent?.messages[tab] : (tab | titlecase) }}
                                    </div>
                                </ng-container>
                            </ds-tab>
                        }
                    </ds-tabs-group>
                </div>
            }
            @if (!isDesktop) {
                <user-compliance-message></user-compliance-message>
            }
            <router-outlet></router-outlet>
            <ph-seo-page-content [pageName]="productName"></ph-seo-page-content>
        </div>
    }
</ng-container>
